import React, { useState } from 'react';

import { GlobalAccountSettlementRule } from '@ndvr/billing-api';

import { useRequiredParams } from 'utils';
import { Text, VerticalLayout } from 'widgets';

import { useDeleteGlobalAccountSettlementRule, useGlobalAccountSettlementRuleTimeline } from './billing-queries';
import { SettlementProfileDrawer } from './drawers/SettlementProfileDrawer';
import { TimelinePanel } from './TimelinePanel';
import { SettlementTitle } from './widgets/SettlementTitle';
import { TimelineHeader } from './widgets/TimelineHeader';

export const SettlementProfilePanel = () => {
    const { globalAccountGUID } = useRequiredParams(['globalAccountGUID']);

    const { data: timeline, isLoading } = useGlobalAccountSettlementRuleTimeline(globalAccountGUID);
    const { mutateAsync: deleteGlobalAccountSettlementRule } = useDeleteGlobalAccountSettlementRule(globalAccountGUID);

    const [editedRule, setEditedRule] = useState<GlobalAccountSettlementRule>();
    const [drawerOpen, setDrawerOpen] = useState(false);

    return (
        <>
            <TimelineHeader
                title="Settlement"
                buttonLabel="+ New Settlement Profile"
                onClick={() => {
                    setEditedRule(undefined);
                    setDrawerOpen(true);
                }}
            />
            <TimelinePanel
                timeline={timeline}
                isLoading={isLoading}
                onEdit={(rule) => {
                    setEditedRule(rule);
                    setDrawerOpen(true);
                }}
                onDelete={(rule) => deleteGlobalAccountSettlementRule(rule.globalAccountSettlementRuleGUID)}
                firstColumnRenderer={({ rule }) => (
                    <VerticalLayout>
                        <SettlementTitle
                            settlementType={rule.settlementForFixedFees}
                            portfolioGUID={rule.portfolioForFixedFees}
                        />
                        <Text $themeColor="subtle">Membership fee</Text>
                    </VerticalLayout>
                )}
                secondColumnRenderer={({ rule }) => (
                    <VerticalLayout>
                        <SettlementTitle
                            settlementType={rule.settlementForVariableFees}
                            portfolioGUID={rule.portfolioForVariableFees}
                        />
                        <Text $themeColor="subtle">AUM charge</Text>
                    </VerticalLayout>
                )}
            />
            {drawerOpen && (
                <SettlementProfileDrawer
                    globalAccountSettlementRule={editedRule}
                    onClose={() => setDrawerOpen(false)}
                />
            )}
        </>
    );
};
